// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-StopeButton-module--cls1--2Ha2V","cls2":"contacts-StopeButton-module--cls2--2Wyqc contacts-StopeButton-module--cls1--2Ha2V"};